var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoBeHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiles_beamProIcon_1_",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    className: "st0",
    d: "M198.9,511h106.5 M324.1,511h128.5c9,0,16.3-7.2,16.3-16.2c0,0,0,0,0-0.1v-86.8 c-0.1-9-7.3-16.2-16.3-16.3h-49.9V18.9c0-9-7.2-16.2-16.2-16.3c0,0,0,0-0.1,0H122.6c-9,0-16.3,7.2-16.3,16.2c0,0,0,0,0,0.1v372.8 h-54c-9,0-16.3,7.2-16.3,16.2c0,0,0,0,0,0.1v86.8c0,9,7.2,16.3,16.2,16.3c0,0,0,0,0.1,0h128.2 M257.4,17c9.1,0,16.4,7.3,16.5,16.3 c0,0.1,0,0.1,0,0.2c0.2,9-7,16.3-15.9,16.5c0,0,0,0,0,0h-0.5c-9.1,0-16.5-7.4-16.5-16.5C240.9,24.4,248.3,17,257.4,17L257.4,17z  M368.3,390.8H139.7V72.9h228.5v317.8L368.3,390.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "person",
    transform: "translate(39.938 65.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    className: "st0",
    d: "M252.8,132.7c-20.9-21.6-55.4-22.2-77.1-1.3c-0.4,0.4-0.8,0.8-1.2,1.2 c-10.1,11.2-15.1,26.2-13.7,41.2c2.3,31.2,26,56.5,52.9,56.5s50.6-25.3,52.9-56.5C268,158.8,263,143.9,252.8,132.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    className: "st0",
    d: "M303.5,344.6H123.9c-4.8,0.1-9.3-2-12.3-5.7c-3.4-4.2-4.7-9.6-3.7-14.8 c4.3-23.9,18.4-44.9,38.9-58c40.9-25.8,93-25.8,133.8,0c20.5,13.1,34.5,34.1,38.9,58c1,5.2-0.3,10.7-3.7,14.8 C312.8,342.6,308.3,344.7,303.5,344.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBeHead);
export default __webpack_public_path__ + "static/media/GoBe-head.c91ade173aeb5b40613f23c14f3661cc.svg";
export { ForwardRef as ReactComponent };